import React from 'react';
import { format } from 'date-fns';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { MONTH_DASH_YEAR_FORMAT, MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { IDatetime } from '@framework/date-helpers/Datetime';

const MaturityDateCell = ({ row: { maturityDate } } : { row: { maturityDate: IDatetime } }) => {
  if (!maturityDate || !maturityDate.dateTime) {
    return <>-</>;
  }

  return (
    <Tooltip content={ format(new Date(maturityDate.dateTime), MONTH_DAY_YEAR_FORMAT) }>
      { format(new Date(maturityDate.dateTime), MONTH_DASH_YEAR_FORMAT) }
    </Tooltip>
  );
};

export default MaturityDateCell;
